export const navigation = {
  'Go back': 'Retour',
  'Go forward': 'Avancer',
};
